import { j as ab2hex, k as buildOperationSignature, m as buildOperationSignatureMessage, n as buildOperationSignatureParams, o as buildSignedOperation, p as calculateSkipsLeft, f as createAction, b as createDocument, a as createExtendedState, c as createReducer, q as createUnsafeReducer, r as createZip, t as documentHelpers, u as getLocalFile, v as getRemoteFile, w as getUnixTimestamp, x as hashDocument, y as hashKey, z as hex2ab, i as isBaseAction, A as isNoopOperation, C as isSameDocument, D as isUndoRedo, l as loadFromFile, e as loadFromInput, E as mapSkippedOperations, F as parseResultingState, G as readOnly, H as replayDocument, I as replayOperations, s as saveToFile, d as saveToFileHandle, J as sortMappedOperations, K as sortOperations, L as validateOperations, M as verifyOperationSignature, B as BaseDocument, h as BaseActions, g as applyMixins, N as baseReducer, O as mutableBaseReducer, P as processUndoRedo, Q as updateDocument, R as updateHeader, S as zod } from "./object-CY74acQg.js";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ab2hex,
  buildOperationSignature,
  buildOperationSignatureMessage,
  buildOperationSignatureParams,
  buildSignedOperation,
  calculateSkipsLeft,
  createAction,
  createDocument,
  createExtendedState,
  createReducer,
  createUnsafeReducer,
  createZip,
  documentHelpers,
  getLocalFile,
  getRemoteFile,
  getUnixTimestamp,
  hashDocument,
  hashKey,
  hex2ab,
  isBaseAction,
  isNoopOperation,
  isSameDocument,
  isUndoRedo,
  loadFromFile,
  loadFromInput,
  mapSkippedOperations,
  parseResultingState,
  readOnly,
  replayDocument,
  replayOperations,
  saveToFile,
  saveToFileHandle,
  sortMappedOperations,
  sortOperations,
  validateOperations,
  verifyOperationSignature
}, Symbol.toStringTag, { value: "Module" }));
const Document = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseDocument,
  actions: BaseActions,
  applyMixins,
  baseReducer,
  mutableBaseReducer,
  processUndoRedo,
  updateDocument,
  updateHeader,
  utils: index,
  z: zod
}, Symbol.toStringTag, { value: "Module" }));
export {
  Document as D,
  index as i
};
//# sourceMappingURL=index-Db40bdYP.js.map
